import { type Pinia } from 'pinia'

export default defineNuxtPlugin((nuxtApp) => {
  const logger = useLogger()

  // Global Vue error handler
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    logger.handleError(error, `Vue Global Error - ${info}`)
  }

  // Global error boundary
  nuxtApp.vueApp.mixin({
    setup() {
      onErrorCaptured((error, instance, info) => {
        logger.handleError(error, `Setup Error - ${info}`)
        return false // prevent error from propagating
      })
    }
  })

  // Handle window errors
  if (process.client) {
    window.addEventListener('error', (event) => {
      logger.handleError(event.error, `Window Error - ${event.type}`)
    })

    window.addEventListener('unhandledrejection', (event) => {
      logger.handleError(event.reason, 'Unhandled Promise Rejection')
    })
  }

  // Handle Nuxt errors
  nuxtApp.hook('vue:error', (error) => {
    logger.handleError(error, 'Nuxt Vue Error')
  })

  nuxtApp.hook('app:error', (error) => {
    logger.handleError(error, 'Nuxt App Error')
  })

  // Optional: Add router error handling
  const router = useRouter()
  router.onError((error, to) => {
    logger.handleError(error, `Router Error - navigating to ${to.fullPath}`)
  })

  // Optional: Add Pinia error handling
  const pinia = usePinia() as Pinia
  if (pinia) {
    pinia.use(() => ({
      error(error) {
        logger.handleError(error, 'Pinia Store Error')
      }
    }))
  }
}) 